import axios from "axios";
import http from "../http-common";

// where the backend is running+/api+/auth/
const API_URL = "https://be-dev.quickquotescabinets.com/api/auth/";
//const API_URL = "http://localhost:8080/api/auth/";

const forgotPasswordEmail = (email) => {
  console.log("email");
  console.log(email);
  return axios.put(API_URL + "forgotpasswordemail", {
    email: email
  });
};

const verifyEmail = (email) => {
  console.log("email");
  console.log(email);
  return axios.put(API_URL + "sendverificationemail", {
    email: email
  });
};

const register = (userfirstname, userlastname, email, password, confirmpassword, roles) => {
  return axios.post(API_URL + "signup", {
    userfirstname,
    userlastname,
    email,
    password,
    confirmpassword,
    roles,
  });
};

const login = (email, password) => {
  
  {/** for testing purposes only
  
  const user = {id:1, username: "username", roles: "admin", accessToken: "yes"};
  
  const response = {data: {
    id: user.id,
    username: user.username,
    email: user.email,
    roles: user.roles,
    accessToken: user.accessToken
  }};

  if (response.data.accessToken) {
    localStorage.setItem("user", JSON.stringify(response.data));
  }

  return response.data;
  */}

  return axios
    .post(API_URL + "signin", {
      email,
      password,
    })
    .then((response) => {
      if (response.data.accessToken) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }
      return response.data;
    });
    {/**
    .catch(() => {
      console.log(response.data);
      localStorage.setItem("user", JSON.stringify(response.data));
      return response.data;
    }); */}
    

};

const logout = () => {
  localStorage.removeItem("user");
};

const changepsw = (id,currpassword,newpassword) => {
  return http
    .put(API_URL + "changepsw", {
      id,
      currpassword,
      newpassword,
    })
    .then((response) => {
      if (response.data.accessToken) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }

      return response.data;
    });
}


const resetpsw = (requesteriduser, iduser,newpassword) => {
  return http
    .put(API_URL + "resetpsw", {
      requesteriduser,
      iduser,
      newpassword,
    })
    .then((response) => {
      //if (response.data.accessToken) {
      //  localStorage.setItem("user", JSON.stringify(response.data));
      //}

      return response.data;
    });
}

export default {
  verifyEmail,
  register,
  login,
  logout,
  changepsw,
  resetpsw,
  forgotPasswordEmail
};